import { Component, Input } from '@angular/core';
import { BreadcrumbItem, QaiBadgeComponent, QaiBreadcrumbListComponent, QaiInnerWrapComponent, QaiItemGridComponent, QaiLoadingComponent } from '@qai/ui';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { TranslationService } from 'src/app/services/translation.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-user-header',
  templateUrl: './user-header.component.html',
  styleUrls: ['./user-header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    QaiInnerWrapComponent,
    QaiBreadcrumbListComponent,
    QaiItemGridComponent,
    QaiBadgeComponent,
    QaiLoadingComponent,
    TranslocoModule
  ],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'reportingV2',
    }
  ]
})
export class UserHeaderComponent {
  @Input() userName: string = '';
  @Input() totalAssignments: number = 0;
  @Input() certifiedAssignments: number = 0;
  @Input() totalCertificationAssignments: number = 0;
  @Input() totalSessions: number = 0;
  @Input() hoursSpentPracticing: number = 0;
  @Input() lastLogin: string = '';
  @Input() memberOfTeams: string = '';
  @Input() isLoading: boolean = false;

  isTranslationLoaded = false;

  constructor(
    private translocoService: TranslocoService,
    private translationService: TranslationService,
  ) { }

  ngOnInit(): void { 
    this.translationService.loadScopedTranslation('reportingV2').then(() => {
      this.isTranslationLoaded = true
    });
  }


  getBreadcrumbItems(): BreadcrumbItem[] {
    return [
      { text: this.translocoService.translate('reportingV2.DASHBOARD'), href: '/reporting_dashboard' },
      { text: '', href: '', active: true }
    ];
  }
}
